<ng-container *ngIf="(alerts$ | async) && (!!!alerts)">
    <label class="mb-0 personal-info">{{ 'account.details.alerts' | translate }}</label>
    <div class="container p-2">
      <ng-container *ngFor="let alert of alerts">
        <div class="d-flex">
          <input
            type="checkbox"
            [(ngModel)]="alert.Status"
            [ngModelOptions]="{standalone: true}"
            disabled = "{{editMode}}"
          />
          <span class="px-2">{{ alert.AlertTitle }}</span>
        </div>
      </ng-container>
    </div>
  </ng-container>